import React from 'react';
import { TrendingUp, Users, Cpu, ShieldCheck } from 'lucide-react';
import styles from './RightPanel.module.css';

interface RightPanelProps {
  trendingTags: { tag: string; count: number }[];
  onSearchTag: (tag: string) => void;
}

export const RightPanel: React.FC<RightPanelProps> = ({ trendingTags, onSearchTag }) => {
  const recommendedUsers = [
    {
      id: 'usr_sarah_design',
      displayName: 'Sarah Connor',
      username: 'sarah_design',
      avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&auto=format&fit=crop&q=80',
    },
    {
      id: 'usr_cordle_official',
      displayName: 'Cordle Team',
      username: 'cordle',
      avatarUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=400&auto=format&fit=crop&q=80',
    },
  ];

  return (
    <aside className={styles.rightPanel}>
      {/* Cloudflare Tech Architecture Badge */}
      <div className={styles.card} style={{ background: 'linear-gradient(135deg, rgba(99,102,241,0.1), rgba(16,185,129,0.05))' }}>
        <div className={styles.cardTitle}>
          <Cpu size={18} color="var(--accent-primary)" />
          <span>Cloudflare Edge Stack</span>
        </div>
        <div style={{ marginBottom: '10px', fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
          100% Free-Tier Compatible Architecture
        </div>
        <div>
          <span className={styles.techPill}>⚡ Workers</span>
          <span className={styles.techPill}>💾 D1 SQLite</span>
          <span className={styles.techPill}>📦 R2 Storage</span>
          <span className={styles.techPill}>🔑 KV Cache</span>
          <span className={styles.techPill}>💬 Durable Objects</span>
        </div>
      </div>

      {/* Trending Topics */}
      <div className={styles.card}>
        <div className={styles.cardTitle}>
          <TrendingUp size={18} color="var(--accent-primary)" />
          <span>Trending Hashtags</span>
        </div>
        {trendingTags.map((item) => (
          <div key={item.tag} className={styles.trendItem} onClick={() => onSearchTag(item.tag)}>
            <span className={styles.tag}>{item.tag}</span>
            <span className={styles.count}>{item.count} posts</span>
          </div>
        ))}
      </div>

      {/* Recommended Creators */}
      <div className={styles.card}>
        <div className={styles.cardTitle}>
          <Users size={18} color="var(--accent-primary)" />
          <span>Who to Follow</span>
        </div>
        {recommendedUsers.map((user) => (
          <div key={user.id} className={styles.userRow}>
            <div className={styles.userInfo}>
              <img src={user.avatarUrl} alt={user.displayName} className={styles.avatar} />
              <div>
                <div className={styles.displayName}>{user.displayName}</div>
                <div className={styles.username}>@{user.username}</div>
              </div>
            </div>
            <button className={styles.followBtn}>Follow</button>
          </div>
        ))}
      </div>
    </aside>
  );
};
